app.initializers.add('bagiril/payments', () => {
  console.log('[bagiril/payments] Hello, forum!');
});
